import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer-quality">
      <div className="footer-container">
        <p>&copy; {new Date().getFullYear()} Quality Seal. Todos los derechos reservados.</p>
        <span className="footer-subtext">Construido con ❤️ para rutas eficientes.</span>
      </div>
    </footer>
  );
};

export default Footer;
